import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FloatingCard } from '../../component-floating-card';
import { forwardRef } from 'react';
/**
 * The `Popover` is a non-modal dialog that floats around a trigger.
 * It is used to display contextual information
 */
export const Popover = forwardRef((props, ref) => (_jsx(FloatingCard, { elevation: "high", variant: "default", ...props, ref: ref })));
Popover.displayName = 'Popover';
